import { StepDefinitionStrategy } from './step-definition.strategy';
import { Injectable } from '@angular/core';
import { RouteIds, Step } from '../../types';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';

@Injectable({
  providedIn: 'root',
})
export class PaymentStepDefinitionService implements StepDefinitionStrategy {
  private stepDefinition: Step = {
    id: RouteIds.payment,
    nextStep: () => RouteIds.confirmation,
    googleAnalyticsEvent: GoogleAnalyticsEventEnum.Payment,
  };

  getStepDefinition() {
    return {
      ...this.stepDefinition,
    };
  }
}
